module.exports = __webpack_public_path__ + "img/Cooperation.bb013ca2.svg";